import { partnersModule } from './store/partners'
import { categoriesModule } from './store/category'
import { tagsModule } from './store/tags'
import { createModule } from '@vue-storefront/core/lib/module'

export const PARTNERS_KEY = 'partners'
export const PARTNERS_CATEGORIES_KEY = 'partner_categories'
export const PARTNERS_TAGS_KEY = 'partner_tags'
export const Partners = createModule({
  key: 'partners',
  store: {
    modules: [
      {
        key: PARTNERS_KEY,
        module: partnersModule
      },
      {
        key: PARTNERS_CATEGORIES_KEY,
        module: categoriesModule
      },
      {
        key: PARTNERS_TAGS_KEY,
        module: tagsModule
      }
    ]
  }
})
